import { InstantSearchSortOrder } from '../types';

export const getQueryStateSortOrder = (order?: string | null): InstantSearchSortOrder => {
  if (order === 'descend' || order === 'desc') {
    return InstantSearchSortOrder.DESC;
  }
  return InstantSearchSortOrder.ASC;
};
